<form name="material_signup_form container" [formGroup]="form" (submit)="submit()" *ngIf="userProfile">
  <input type="hidden" name="id" formControlName="id" />
  <fieldset>
    <h6 class="text-primary mt-2">{{ 'PersonalInfo.Title' | translate }}</h6>

    <div class="row">
      <!-- Title -->
      <div class="col-md-2">
        <ng-container *ngIf="form.controls.titleId.value !== titleOtherId">
          <mat-form-field class="w-100" *ngIf="!readonly">
            <mat-label>{{ 'PersonalInfo.PersonTitle' | translate }}</mat-label>
            <mat-select formControlName="titleId" name="titleId" (selectionChange)="select($event.value, 'Title')">
              <mat-option *ngFor="let title of titles" [value]="title.id">
                {{ title.label }}
              </mat-option>
            </mat-select>
            <mat-error> {{ 'PersonalInfo.TitleRequired' | translate }} </mat-error>
          </mat-form-field>
          <mat-form-field *ngIf="readonly" class="w-100">
            <input
              [readonly]="readonly"
              matInput
              [placeholder]="'PersonalInfo.PersonTitle' | translate"
              [value]="getTitle()"
              required
            />
          </mat-form-field>
        </ng-container>
        <ng-container>
          <mat-form-field class="w-100" [hidden]="form.controls.titleId.value !== titleOtherId">
            <input
              matInput
              #txtTitleOther
              formControlName="titleOther"
              [readonly]="readonly"
              [placeholder]="'PersonalInfo.PersonTitle' | translate"
              [maxLength]="10"
            />
            <mat-icon *ngIf="!readonly" matSuffix class="cursor-pointer" (click)="clearOther('title')">close</mat-icon>
            <mat-error> {{ 'PersonalInfo.TitleRequired' | translate }} </mat-error>
          </mat-form-field>
        </ng-container>
      </div>

      <!-- First Name -->
      <div class="col-md-5">
        <mat-form-field class="w-100">
          <input
            matInput
            placeholder="{{ 'PersonalInfo.FirstName' | translate }}"
            formControlName="firstName"
            name="firstname"
            [readonly]="readonly"
            required
          />
          <mat-error kj-error [control]="form.get('firstName')"></mat-error>
        </mat-form-field>
      </div>
      <!-- Last Name -->
      <div class="col-md-5">
        <mat-form-field class="w-100">
          <input
            matInput
            placeholder="{{ 'PersonalInfo.LastName' | translate }}"
            formControlName="lastName"
            name="lastName"
            [readonly]="readonly"
            required
          />
          <mat-error kj-error [control]="form.get('lastName')"></mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="form-row">

      <!-- Year of Birth -->
      <div class="col">
        <mat-form-field class="w-100">
          <mat-label>{{ 'PersonalInfo.YearOfBirth' | translate }}</mat-label>
          <input
            matInput
            formControlName="yearOfBirth"
            [readonly]="readonly"
            [matAutocomplete]="yearOfBirthAutoComplete"
            required
          />
          <mat-autocomplete #yearOfBirthAutoComplete="matAutocomplete" autoActiveFirstOption  (opened)="yearOfBirthOpen()">
            <mat-option *ngFor="let year of filteredYearOfBirthOptions$ | async" class="mat-option year-of-birth value-{{year}}" [value]="year">
              {{year}}
            </mat-option>
          </mat-autocomplete>
          <mat-error kj-error [control]="form.get('yearOfBirth')"></mat-error>
        </mat-form-field>
        <!-- <pre>{{form.controls.yearOfBirth.errors|json}}</pre> -->
      </div>

      <!-- Language -->
      <div class="col">
        <mat-form-field class="w-100" *ngIf="!readonly">
          <mat-label>{{ 'PersonalInfo.MotherTongue' | translate }}</mat-label>
          <mat-select formControlName="maternalLanguageId" name="maternalLanguageId" required>
            <mat-option *ngFor="let language of knownLanguages" [value]="language.id">
              {{ language.label }}
            </mat-option>
          </mat-select>
          <mat-error kj-error [control]="form.get('maternalLanguageId')"></mat-error>
        </mat-form-field>
        <mat-form-field *ngIf="readonly" class="w-100">
          <input
            [readonly]="readonly"
            matInput
            [placeholder]="'PersonalInfo.MotherTongue' | translate"
            [value]="getMotherTongue()"
            required
          />
        </mat-form-field>
      </div>
    </div>
    <h6 class="text-primary mt-2">
      {{ 'PersonalInfo.AddressTitle' | translate }}
    </h6>
    <div formGroupName="address">
      <div class="form-row">
        <!-- Address -->
        <div class="col-md-8">
          <mat-form-field class="w-100">
            <input
              matInput
              placeholder="{{ 'PersonalInfo.Address' | translate }}"
              formControlName="streetName"
              name="streetName"
              [readonly]="readonly"
              required
            />
            <mat-error kj-error [control]="form.get('address.streetName')"></mat-error>
          </mat-form-field>
        </div>
        <!-- City/Town -->
        <div class="col-md-4">
          <mat-form-field class="w-100">
            <input
              matInput
              placeholder="{{ 'PersonalInfo.CityTown' | translate }}"
              formControlName="city"
              name="city"
              [readonly]="readonly"
              required
            />
            <mat-error kj-error [control]="form.get('address.city')"></mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="form-row">
        <!-- Province -->
        <div class="col-md-5">
          <mat-form-field class="w-100" *ngIf="!readonly">
            <mat-label>{{ 'PersonalInfo.Province' | translate }}</mat-label>
            <mat-select formControlName="provinceId" name="provinceId" required>
              <mat-option *ngFor="let province of provinces" [value]="province.id">
                {{ province.label }}
              </mat-option>
            </mat-select>
            <mat-error kj-error [control]="form.get('address.provinceId')"></mat-error>
          </mat-form-field>
          <mat-form-field *ngIf="readonly" class="w-100">
            <input
              [readonly]="readonly"
              matInput
              [placeholder]="'PersonalInfo.Province' | translate"
              [value]="getProvince()"
              required
            />
          </mat-form-field>
        </div>
        <!-- Postal Code -->
        <div class="col-md-4">
          <mat-form-field class="w-100">
            <input
              matInput
              placeholder="{{ 'PersonalInfo.PostalCode' | translate }}"
              formControlName="postalCode"
              name="postalCode"
              [readonly]="readonly"
              class="text-uppercase"
              required
            />
            <mat-error kj-error [control]="form.get('address.postalCode')"></mat-error>
          </mat-form-field>
        </div>
      </div>
      <div *ngIf="showPostalCodeWarning()" class="alert alert-danger">
        {{ 'PersonalInfo.ProvincePostalMismatch' | translate }}
      </div>
    </div>
    <h6 class="text-primary mt-2">
      {{ 'PersonalInfo.AdditionalInfoTitle' | translate }}
    </h6>
    <div class="form-row">
      <!-- Language of communication -->
      <div class="col">
        <mat-form-field class="w-100" *ngIf="!readonly">
          <mat-label>{{ 'PersonalInfo.LanguageOfCommunication' | translate }}</mat-label>
          <mat-select formControlName="communicationLanguageId" name="communicationLanguageId" required>
            <mat-option *ngFor="let language of languages" [value]="language.id">
              {{ 'Locale.' + language.code | translate }}
            </mat-option>
          </mat-select>
          <mat-error kj-error [control]="form.get('communicationLanguageId')"></mat-error>
        </mat-form-field>
        <mat-form-field *ngIf="readonly" class="w-100">
          <input
            [readonly]="readonly"
            matInput
            [placeholder]="'PersonalInfo.LanguageOfCommunication' | translate"
            [value]="'Locale.' + getCommLanguage() | translate"
            required
          />
        </mat-form-field>
      </div>
      <!-- Profession -->
      <div class="col">
        <mat-form-field class="w-100 profession-field" *ngIf="!readonly">
          <mat-label>{{ 'PersonalInfo.Profession' | translate }}</mat-label>
          <mat-select formControlName="professionId" name="professionId" required>
            <mat-option *ngFor="let profession of professions" [value]="profession.id">
              {{ profession.label }}
            </mat-option>
          </mat-select>
          <mat-error kj-error [control]="form.get('professionId')"></mat-error>
        </mat-form-field>
        <mat-form-field *ngIf="readonly" class="w-100">
          <input
            [readonly]="readonly"
            matInput
            [placeholder]="'PersonalInfo.Profession' | translate"
            [value]="getProfession()"
            required
          />
        </mat-form-field>
        <small class="cursor-pointer text-grey" [hidden]="readonly" (click)="openDialog()">
          {{ 'PersonalInfo.ProfessionNotListedLink' | translate }}
        </small>
      </div>
    </div>

    <div class="form-row">
      <!-- Agree to Terms Of Service -->
      <div class="col">
        <mat-checkbox *ngIf="authService.getUserId() === userProfile.id" formControlName="isAgreedToTOS"></mat-checkbox>
        <div class="d-inline-block" *ngIf="authService.getUserId() !== userProfile.id">
          <mat-icon class="align-bottom" *ngIf="userProfile.isAgreedToTOS">check_box</mat-icon>
          <mat-icon class="align-bottom" *ngIf="!userProfile.isAgreedToTOS">check_box_outline_blank</mat-icon>
        </div>
        {{ 'Register.Terms.Prefix' | translate }}
        <span class="link" (click)="commonDialogService.showTerms()" translate="Register.Terms.TermsLink"></span>
        {{ 'Register.Terms.Middle' | translate }}
        <span class="link" (click)="commonDialogService.showPrivacy()" translate="Register.Terms.PoliciesLink"></span>
        <mat-error class="small" *ngIf="authService.getUserId() === userProfile.id">
          <ng-container *ngIf="form.controls.isAgreedToTOS.hasError('mustAgreeToTOS')">
            {{ 'AuthErrors.MustAgree' | translate }}
          </ng-container>
        </mat-error>
      </div>
    </div>

    <!-- Button -->
    <button mat-raised-button color="primary" class="float-right" role="button" type="submit" [hidden]="readonly">
      {{ this.buttonText || 'Global.Save' | translate }}
    </button>
  </fieldset>
</form>
